import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Icon } from '../../atoms';
// Do not shorten the import path, it breaks workflow-button otherwise
import { Workflow } from '../workflow-button/types';
const iconByWorkflow = {
    [Workflow.AddCash]: 'Add',
    [Workflow.Buy]: 'ArrowUpward',
    [Workflow.Funds]: 'Work',
    [Workflow.Receive]: 'CallReceived',
    [Workflow.Sell]: 'ArrowDownward',
    [Workflow.Send]: 'ArrowOutward',
    [Workflow.Transfer]: 'SettingsEthernet',
    [Workflow.WithdrawCash]: 'Remove',
};
export function WorkflowIcon({ name, pressed, bordered = false, }) {
    const icon = iconByWorkflow[name];
    return (_jsx(View, { style: [$.container, bordered && $.borderedContainer], children: _jsx(Icon, { name: icon, size: "sm", color: pressed ? 'inverse' : 'primary' }) }));
}
const $ = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    borderedContainer: {
        width: 32,
        height: 32,
        backgroundColor: theme.color.background.white,
        borderRadius: theme.radius.sm,
        borderWidth: 1,
        borderColor: theme.color.border.primary,
    },
});
